
import React, { useState, useEffect } from "react";
import { ThumbDown, ThumbUp } from "@mui/icons-material";
import "./MessageCodes.css";

const MessageA23 = (props) => {
  const { index, item, handleClick, setTextOnClick } = props;

  // Initialize both thumbs as active by default
  const [activeThumbs, setActiveThumbs] = useState({ up: true, down: true });

  const handleThumb = (direction) => {
    const updatedActiveThumbs = { ...activeThumbs };

    if (direction === "up") {
      updatedActiveThumbs.up = true;
      updatedActiveThumbs.down = false;
    
      document.querySelector(`.thumb-down-${index}`)?.classList.remove("active");
      document.querySelector(`.thumb-up-${index}`)?.classList.add("active");
    } else if (direction === "down") {
      updatedActiveThumbs.down = true;
      updatedActiveThumbs.up = false;
     
      document.querySelector(`.thumb-up-${index}`)?.classList.remove("active");
      document.querySelector(`.thumb-down-${index}`)?.classList.add("active");
    }

    setActiveThumbs(updatedActiveThumbs);

    handleClick(item.code, null, item.text);
    setTextOnClick(item.text);
  };

  useEffect(() => {
    if (activeThumbs.up) {
      document.querySelector(`.thumb-up-${index}`)?.classList.add("active");
    }
    if (activeThumbs.down) {
      document.querySelector(`.thumb-down-${index}`)?.classList.add("active");
    }
  }, [index, activeThumbs]);

  return (
    <div className="a1-wrap" style={{ width: "fit-content" }}>
      <div style={{ width: "fit-content", margin: 10 }}></div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "start",
        }}
      >
        {item?.uiCommand === "A23" && (
          <>
            {item?.text === "Thumbs Up" && (
              <div
                className={`thumb-up thumb-up-${index} ${activeThumbs.up ? "active" : ""}`}
                onClick={() => handleThumb("up")}
              >
                <ThumbUp className="action-tab" />
              </div>
            )}
            {item?.text === "Thumbs Down" && (
              <div
                className={`thumb-down thumb-down-${index} ${activeThumbs.down ? "active" : ""}`}
                onClick={() => handleThumb("down")}
              >
                <ThumbDown className="action-tab" />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MessageA23;